export const getMessagingRole = (roles: string[]) =>
  roles.filter((role) => role.includes("messaging"));
